var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealtimeUpdates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 2.16602L13.333 4.82662L13.2541 4.90567M13.2541 4.90567L10.6663 7.49935M13.2541 4.90567C12.8427 4.85747 12.4241 4.83268 11.9997 4.83268C6.10863 4.83268 1.33301 9.60831 1.33301 15.4993C1.33301 18.8679 2.89443 21.8717 5.33301 23.8265M13.333 23.4995L10.6663 26.0471L10.7059 26.0883M10.7059 26.0883C11.1299 26.1396 11.5618 26.166 11.9997 26.166C17.8907 26.166 22.6663 21.3904 22.6663 15.4993C22.6663 12.1308 21.1049 9.12702 18.6663 7.17219M10.7059 26.0883L13.333 28.8328",
    stroke: "#665DB7",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimeUpdates);
export default __webpack_public_path__ + "static/media/realtime-updates.a55ed7ede2cb82ce1518fca2e9d635fd.svg";
export { ForwardRef as ReactComponent };